/** Accordion */
$('.accordion-button').click(function() {
    $(this).toggleClass('active');
    $(this).parent('.accordion').toggleClass('accordion-active');
    $('#accordion-' + jQuery(this).attr('data-attr')).slideToggle();
    $('.icon', jQuery(this)).toggleClass('active');
});

// Expand All / Collapse All functionality
$('.btn-expand-all').click(function() {
    var accordion_id = $(this).attr('data-attr');
    var action = $(this).attr('data-action');
    console.log('the action is ' + action);

    if (action == 'expand') { // Expand all
        $(this).attr('data-action', 'collapse');
        $(this).html('Collapse All');
        $('.accordion-' + accordion_id + ' .accordion-button').each(function() {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
                $('#accordion-' + $(this).attr('data-attr')).slideToggle();
                $('.icon', jQuery(this)).toggleClass('active');
            }
        });
    } else {
        $(this).attr('data-action', 'expand');
        $(this).html('Expand All');
        $('.accordion-' + accordion_id + ' .accordion-button').each(function() {
            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('#accordion-' + $(this).attr('data-attr')).slideToggle();
                $('.icon', jQuery(this)).toggleClass('active');
            }
        });
    }
});